import { format } from 'fecha';

import { Component, Inject, Input, SimpleChanges } from '@angular/core';

import { BankAccountStatus, EnumTranslatorBase } from '@skylab-shared/dataModel';

import { CommonColors } from '@inscomponents/core';
import { EnumTranslator, L10n, L10nBase } from '@skylab-angular-shared/core';
import { TooltipDirective, IconComponent } from '@skylab-angular-shared/ui';
import { DataFormats } from '@skylab-shared/constants';
import { IconName } from '@skylab-assets/icons';

@Component({
    selector: 'skl-client-bank-account-status',
    templateUrl: './client-bank-account-status.component.html',
    imports: [TooltipDirective, IconComponent]
})
export class ClientBankAccountStatusComponent {

    @Input() public status!: BankAccountStatus;
    @Input() public statusDate!: Date;
 
    public statusInfo!: {
        name: IconName;
        color: CommonColors;
        innerColor?: CommonColors;
        tooltip: string[];
    };
 
    public constructor(
        @Inject(EnumTranslator) public readonly enumTranslator: EnumTranslatorBase,
        @Inject(L10n) public readonly l10n: L10nBase) {
    }
 
    public ngOnInit(): void {
        this.setInfo();
    }
 
    public ngOnChanges(changes: SimpleChanges): void {
        if ((changes['status'] && !changes['status'].firstChange) || (changes['statusDate'] && !changes['statusDate'].firstChange)) {
            this.setInfo();
        }
    }
 
    private setInfo(): void {
        const style = this.getStatusStyle();
        const tooltip = this.getStatusTooltip();
        this.statusInfo = {
            color: style.color,
            innerColor: style.innerColor,
            tooltip: tooltip,
            name: style.name
        };
    }
 
    private getStatusStyle(): {name: IconName, color: CommonColors, innerColor?: CommonColors} {
        switch (this.status) {
            case BankAccountStatus.Present:
                return {name: 'check', color: 'success'};
            case BankAccountStatus.Missing:
                return {name: 'circle', color: 'error'};
            case BankAccountStatus.Unverified:
                return {name: 'circle', color: 'secondary', innerColor: 'secondary'};
            default:
                return {name: 'circle', color: 'secondary'};
        }
    }
 
    private getStatusTooltip(): string[] {
        const statusTooltipText = (this.status === null || this.status === undefined)
            ? ''
            : (this.enumTranslator.getLabeledEnumValue(BankAccountStatus, this.status)?.label ?? '');
 
        const tooltip = [statusTooltipText];
        if (this.status !== BankAccountStatus.Unverified && this.statusDate) {
            tooltip.push(`${this.l10n._T('scenes.clients.form.fields.bank-accounts.columns.status.status-tooltip')}:  ${format(this.statusDate, DataFormats.date.dateTime)}`);
        }
        return tooltip;
 
    }
}
